module.exports = __webpack_public_path__ + "img/Garlan Gudger.9021a2e0.jpg";